<template>
  <div>
    <Dialog
        class="dialog-information"
        :dismissableMask="true"
        :style="{ width: '70vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"

    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi pi-info-circle"></i>
        <h1>מידע</h1>
      </template>

      <div class="p-pt-5 p-grid">
        <div class="p-m-2 p-col p-grid p-ai-center vertical-container  p-jc-center  ">
          <div class="p-pb-2 p-text-center">

            <h1>מה חדש?</h1>
            <h3>

              • דשבורד תלמיד
              <br>
              פונקצייה זו נגישה רק למחנכים

            </h3>
          </div>

        </div>
        <div>
          <div style="background-color: black; width: 1px; height: 100%"></div>
        </div>
        <div class="p-m-2 p-col p-grid p-ai-center vertical-container  p-jc-center  ">
          <div class="p-pb-2 p-text-center">

            <h3>
              מערכת זו עדיין בשלבי הרצה,
              <br>

              ולכן ייתכנו תקלות, אנא התעזרו בסבלנות.
              <br>

              יש לך רעיון איך לשפר ולייעל את המערכת?
              <br>

              כתוב לנו כאן:
            </h3>
            <div class="p-pt-3 p-grid p-ai-center vertical-container  p-jc-center ">
              <Textarea class="p-col p-m-1" v-model="message" rows="1"/>
              <Button class=" p-m-1 p-button-sm" label="שלח" icon="pi pi-send" @click="postMessage"/>
            </div>
          </div>

        </div>
        <div>


        </div>

      </div>


      <template #footer>
        <!--        <div class="p-p-3">-->
        <!--        <Button-->
        <!--            label="ביטול"-->
        <!--            icon="pi pi-times"-->
        <!--            @click="closeDialog"-->
        <!--            class="p-button-sm p-button-secondary"-->
        <!--        />-->
        <!--        <Button class="p-button-sm p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>-->
        <!--        </div>-->
      </template>
    </Dialog>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import Service from "../service/Service";

const {v4: uuidv4} = require("uuid");

export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {
    this.service = new Service();

  },
  watch: {
    show(a, b) {
      setTimeout(() => {
        if (this.show === true && (this.userSettings.informationViewed === false || this.userSettings.id === null)) {
          const userSettings = this.userSettings
          userSettings.informationViewed = true
          this.setUserSettings(userSettings)
          this.service.update(userSettings, "user-settings")
        }
      }, 5000)

    }
  },
  computed: {
    isShow() {
      return this.show
    },
    ...mapState(["userSettings", "user"]),
  },
  data() {
    return {
      message: ""
    };
  },

  methods: {
    ...mapActions([
      "setUserSettings",
    ]),
    closeDialog() {
      this.$emit("closeDialog");
    },
    async postMessage() {
      if (this.message !== "") {
        this.closeDialog()

        const messageObj = {
          id: uuidv4(),
          content: this.message,
          user: this.user.id,
          date : new Date().getTime()
        }

        await this.service
            .post(messageObj, 'user-message')
            .then(() => {
              this.message = ""
              this.openNotification(
                  "success",
                  `מעולה`,
                  `הודעתך התקבלה במערכת`
              );

            })
            .catch(() => {
              this.openNotification(
                  "danger",
                  `אופס`,
                  `קרתה תקלה בשליחת ההודעה`
              );
            });
      } else {
        this.openNotification(
            "danger",
            `אופס`,
            `אנא כתוב הודעה`
        );
      }

    },
    openNotification(
        color,
        title,
        text,
        position = "right-left",
        duration = 3000
    ) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  }
  ,
}
;
</script>

<style>
.p-dialog .p-dialog-footer {
  text-align: left !important;
}

@media screen and (max-width: 1200px) {
  .dialog-information {
    width: 70rem !important;
  }
}

@media screen and (max-width: 992px) {
  .dialog-information {
    width: 95vw !important;
  }
}

@media screen and (max-width: 768px) {
  .dialog-information {
    width: 97vw !important;

  }
}

@media screen and (max-width: 576px) {
  .dialog-information {
    width: 100vw !important;
  }
}
</style>